(function () {
  const previousUpcartShouldAddToCartContinue =
    window.upcartShouldAddToCartContinue;

  window.upcartShouldAddToCartContinue = function (event) {
    const target = event && event.target;
    const isApoProxyButton =
      target instanceof Element &&
      Boolean(
        target.closest(
          '.mw-apo-add-to-cart-cloned, .mw-apo-sticky-add-to-cart-cloned'
        )
      );

    if (isApoProxyButton) {
      return false;
    }

    return typeof previousUpcartShouldAddToCartContinue === 'function'
      ? previousUpcartShouldAddToCartContinue(event)
      : true;
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  const lockedButtons = new WeakSet();

  let pendingButton = null;
  let pendingTimeout = null;

  function releaseButton() {
    if (!pendingButton) return;
    lockedButtons.delete(pendingButton);
    pendingButton.removeAttribute("aria-busy");
    pendingButton.classList.remove("is-adding");
    pendingButton = null;
    if (pendingTimeout) window.clearTimeout(pendingTimeout);
    pendingTimeout = null;
  }

  function refreshAndOpenUpCart() {
    try {
      if (typeof window.upcartRefreshCart === "function") {
        window.upcartRefreshCart();
      }

      setTimeout(() => {
        if (typeof window.upcartOpenCart === "function") {
          window.upcartOpenCart();
        }
      }, 250);
    } catch (err) {
      console.error("Unable to refresh and open UpCart", err);
    }
  }

  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest(".productitem--action-atc");
    if (!btn) return;

    if (lockedButtons.has(btn)) {
      e.preventDefault();
      return;
    }

    lockedButtons.add(btn);
    pendingButton = btn;
    btn.setAttribute("aria-busy", "true");
    btn.classList.add("is-adding");

    if (pendingTimeout) window.clearTimeout(pendingTimeout);
    pendingTimeout = window.setTimeout(releaseButton, 6000);
  });

  window.addEventListener("cartcount:update", () => {
    if (!pendingButton) return;
    refreshAndOpenUpCart();
    releaseButton();
  });
});

// product-shipping-origin.liquid content

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-shipping-origin]').forEach(function (widget) {
    const trigger = widget.querySelector('.acq-shipping-origin__trigger');
    const tooltip = widget.querySelector('.acq-shipping-origin__tooltip');

    if (!trigger || !tooltip) return;

    const openTooltip = () => {
      widget.classList.add('is-open');
      tooltip.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeTooltip = () => {
      widget.classList.remove('is-open');
      tooltip.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = widget.classList.contains('is-open');
      if (isOpen) {
        closeTooltip();
      } else {
        openTooltip();
      }
    });

    widget.addEventListener('mouseenter', openTooltip);
    widget.addEventListener('mouseleave', closeTooltip);

    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) {
        closeTooltip();
      }
    });
  });
});

// Responsive Acqua header surfaces.
(function () {
  if (window.AcquaResponsiveHeaderController) return;
  window.AcquaResponsiveHeaderController = true;

  let returnFocus = null;

  function closeMobileSheets(restoreFocus) {
    document.querySelectorAll('[data-mobile-header-surface]').forEach(function (surface) {
      surface.hidden = true;
      surface.classList.remove('is-open');
    });
    document.querySelectorAll('[data-mobile-header-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('acqua-header-surface-open');
    if (restoreFocus && returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
  }

  function closeTradePanel(restoreFocus) {
    document.querySelectorAll('[data-mobile-trade-hub]').forEach(function (hub) {
      const toggle = hub.querySelector('[data-mobile-trade-toggle]');
      const panel = hub.querySelector('[data-mobile-trade-panel]');
      if (!toggle || !panel) return;
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', 'false');
      hub.classList.remove('is-open');
      panel.hidden = true;
      if (restoreFocus && wasOpen) toggle.focus();
    });
  }

  function closeMobileNav() {
    const nav = document.querySelector('[data-mobile-nav][data-open="true"]');
    if (!nav) return;
    const close = nav.querySelector('[data-mobile-nav-close]');
    if (close) close.click();
  }

  function openMobileSheet(trigger) {
    const target = trigger.getAttribute('data-mobile-header-trigger');
    const surface = document.querySelector('[data-mobile-header-surface="' + target + '"]');
    if (!surface) return;
    const wasOpen = !surface.hidden;
    closeMobileSheets(false);
    closeTradePanel(false);
    closeMobileNav();
    if (wasOpen) {
      trigger.focus();
      return;
    }
    returnFocus = trigger;
    surface.hidden = false;
    surface.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('acqua-header-surface-open');
    const dialog = surface.querySelector('[role="dialog"]');
    if (dialog) dialog.focus();
  }

  document.addEventListener('click', function (event) {
    const mobileTrigger = event.target.closest('[data-mobile-header-trigger]');
    if (mobileTrigger) {
      event.preventDefault();
      openMobileSheet(mobileTrigger);
      return;
    }

    if (event.target.closest('[data-mobile-header-close]')) {
      event.preventDefault();
      closeMobileSheets(true);
      return;
    }

    const tradeToggle = event.target.closest('[data-mobile-trade-toggle]');
    if (tradeToggle) {
      event.preventDefault();
      const hub = tradeToggle.closest('[data-mobile-trade-hub]');
      const panel = hub ? hub.querySelector('[data-mobile-trade-panel]') : null;
      if (!hub || !panel) return;
      const shouldOpen = tradeToggle.getAttribute('aria-expanded') !== 'true';
      closeMobileSheets(false);
      closeMobileNav();
      closeTradePanel(false);
      if (shouldOpen) {
        tradeToggle.setAttribute('aria-expanded', 'true');
        hub.classList.add('is-open');
        panel.hidden = false;
      }
      return;
    }

    if (event.target.closest('[data-menu-toggle], [data-mobile-search-button], .site-header-cart--button')) {
      closeMobileSheets(false);
      closeTradePanel(false);
      if (!event.target.closest('[data-menu-toggle]')) closeMobileNav();
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (document.querySelector('[data-mobile-header-surface]:not([hidden])')) {
        event.preventDefault();
        closeMobileSheets(true);
      } else if (document.querySelector('[data-mobile-trade-toggle][aria-expanded="true"]')) {
        event.preventDefault();
        closeTradePanel(true);
      }
      return;
    }

    if (event.key !== 'Tab') return;
    const surface = document.querySelector('[data-mobile-header-surface]:not([hidden])');
    if (!surface) return;
    const dialog = surface.querySelector('[role="dialog"]');
    const focusable = Array.from(surface.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (item) { return item.offsetParent !== null; });
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024) {
      closeMobileSheets(false);
      closeTradePanel(false);
    }
  });
})();
